module.exports = __webpack_public_path__ + "static/img/banner.a0f08db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.png
// module id = P07D
// module chunks = 52